import { formatDate } from '../../../../app/header/utils'
import { DATE_FORMAT_DB, DATE_FORMAT_INT, LINK_COLUMN_NAME } from '../constants/common'
import { ColumnId, MappedSubpageOrders, Option, OptionRow, OptionsQuery, OptionsSubpage, OptionsView } from '../types'

const DELIMITER = '|'

function parseOrder(input: string | null): MappedSubpageOrders {
  if (!input) return {}
  const parts = input.split(DELIMITER)
  let pricesOrder, volatilityOrder
  if (parts.length === 1) pricesOrder = volatilityOrder = parts[0]
  else [pricesOrder, volatilityOrder] = parts
  return {
    [OptionsSubpage.Prices]: pricesOrder,
    [OptionsSubpage.Volatility]: volatilityOrder,
  }
}

export function orderToString(obj: MappedSubpageOrders): string {
  const arr = [obj[OptionsSubpage.Prices], obj[OptionsSubpage.Volatility]]
  return arr.join(DELIMITER)
}

export type OptionsParsedQuery = ReturnType<typeof parseOptionsQuery>

export function parseOptionsQuery(query: URLSearchParams) {
  const strike = Number(query.get(OptionsQuery.Strike))

  return {
    params: Object.fromEntries(query.entries()) as Record<OptionsQuery, string>, // Re-export the original query as key/val
    ticker: query.get(OptionsQuery.Ticker)!, // Validated on BE
    expiry: query.get(OptionsQuery.Expiry),
    order: parseOrder(query.get(OptionsQuery.Order)),
    strike: Number.isFinite(strike) ? strike : null,
    view: (query.get(OptionsQuery.View) as OptionsView) ?? OptionsView.ChainByDate,
    type: query.get(OptionsQuery.Type) as OptionsSubpage,
  }
}

export function evalLinkOrder(order: string, linkAlias: string) {
  if (!linkAlias) return order
  if (order === LINK_COLUMN_NAME) return linkAlias
  if (order === `-${LINK_COLUMN_NAME}`) return `-${linkAlias}`
  return order
}

export function getViewLink(columnId: ColumnId, searchParams: URLSearchParams, option: Option | OptionRow) {
  const middleLink = new URLSearchParams(searchParams)

  switch (searchParams.get(OptionsQuery.View)) {
    case OptionsView.ChainByStrike:
      middleLink.set(OptionsQuery.View, OptionsView.ChainByDate)
      break
    case OptionsView.ListByDate:
      middleLink.set(OptionsQuery.View, OptionsView.ListByStrike)
      break
    case OptionsView.ListByStrike:
      middleLink.set(OptionsQuery.View, OptionsView.ListByDate)
      break
    case OptionsView.ChainByDate:
    default:
      middleLink.set(OptionsQuery.View, OptionsView.ChainByStrike)
  }

  if (columnId === ColumnId.ExpirationDate) {
    middleLink.delete(OptionsQuery.Strike)
    middleLink.set(OptionsQuery.Expiry, formatDate(option.exDate, DATE_FORMAT_INT, DATE_FORMAT_DB))
  } else {
    middleLink.delete(OptionsQuery.Expiry)
    middleLink.set(OptionsQuery.Strike, option.strike.toString())
  }

  return middleLink
}
